import { render, staticRenderFns } from "./UnrankedPortfolioConfirmationModal.vue?vue&type=template&id=3bcb39d2&scoped=true"
import script from "./UnrankedPortfolioConfirmationModal.vue?vue&type=script&lang=js"
export * from "./UnrankedPortfolioConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./UnrankedPortfolioConfirmationModal.vue?vue&type=style&index=0&id=3bcb39d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcb39d2",
  null
  
)

export default component.exports